import { useState } from 'react';
import { PlacesType } from 'react-tooltip';
import * as S from './styles';
import { Tooltip } from 'components/Widget/Tooltip';

interface SegmentedControlProps {
	children?: React.ReactNode;
}

export function SegmentedControl({ children }: SegmentedControlProps) {
	return <S.Control>{children}</S.Control>;
}

interface SegmentedButtonProps {
	iconColor?: string;

	// optional tooltip will appear on hover
	tooltip?: string;

	// optional placement of tooltip, can be
	// "top", "right", "bottom", or "left". defaults to "top"
	tooltipPlacement?: PlacesType;

	onSelected?: () => void;

	children?: React.ReactNode;
}

export function SegmentedButton({
	tooltip,
	tooltipPlacement = 'bottom',
	onSelected,
	children,
}: SegmentedButtonProps) {
	const [tooltipId] = useState(String(Math.random()));

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	return (
		<>
			<S.Button onClick={onSelected} data-tooltip-id={tooltipId} data-tooltip-content={tooltip}>
				{children}
			</S.Button>
			<Tooltip id={tooltipId} placement={tooltipPlacement} />
		</>
	);
}
